export default (ageInMonths) => ageInMonths < 24 && ageInMonths > -24;
